"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowPersonaOptions = exports.workflowEventStatusOptions = exports.tableColumns = exports.nodeConfigurations = exports.NODE_PIN_CONFIGS = exports.nodeTypes = exports.EVENT_TYPES = void 0;
var event_node_1 = __importDefault(require("./components/nodes/event_nodes/event_node"));
var firebase_notification_node_1 = __importDefault(require("./components/nodes/integration_nodes/firebase_notification_node"));
var sendgrid_node_1 = __importDefault(require("./components/nodes/integration_nodes/sendgrid_node"));
var twilio_node_1 = __importDefault(require("./components/nodes/integration_nodes/twilio_node"));
var xero_node_1 = __importDefault(require("./components/nodes/integration_nodes/xero_node"));
var webhook_node_1 = __importDefault(require("./components/nodes/integration_nodes/webhook_node"));
var delay_node_1 = __importDefault(require("./components/nodes/action_nodes/delay_node"));
var pack_parcel_node_1 = __importDefault(require("./components/nodes/action_nodes/pack_parcel_node"));
var map_data_node_1 = __importDefault(require("./components/nodes/action_nodes/map_data_node"));
var save_data_node_1 = __importDefault(require("./components/nodes/action_nodes/save_data_node"));
var template_node_1 = __importDefault(require("./components/template_node"));
var objectStatuses_1 = require("../../../../../constants/objectStatuses");
var order_product_category_condition_node_1 = __importDefault(require("./components/nodes/condition_nodes/order_product_category_condition_node"));
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var and_condition_node_1 = __importDefault(require("./components/nodes/condition_nodes/and_condition_node"));
var validateForm_1 = require("../../../../../helpers/validateForm/validateForm");
var lookup_node_1 = __importDefault(require("./components/nodes/action_nodes/lookup_node"));
var constants_1 = require("../constants");
var models_1 = require("@letstrade/models");
var order_fulfillment_node_1 = __importDefault(require("./components/nodes/condition_nodes/order_fulfillment_node"));
var create_api_node_1 = __importDefault(require("./components/nodes/event_nodes/create_api_node"));
var eventNodeTypes = {
    event: event_node_1.default,
    api_rest: create_api_node_1.default,
};
exports.EVENT_TYPES = ["event", "api_rest"];
var actionNodeTypes = {
    delay: delay_node_1.default,
    map_data: map_data_node_1.default,
    save_data: save_data_node_1.default,
    template: template_node_1.default,
    pack_parcel: pack_parcel_node_1.default,
};
var lookupNodeTypes = {
    lookup: lookup_node_1.default,
};
var integrationNodeTypes = {
    firebase_notification: firebase_notification_node_1.default,
    sendgrid_email: sendgrid_node_1.default,
    twilio_sms: twilio_node_1.default,
    xero_invoice: xero_node_1.default,
    webhook: webhook_node_1.default,
};
var conditionNodeTypes = {
    filter: order_product_category_condition_node_1.default,
    and_condition: and_condition_node_1.default,
    method_filter: order_fulfillment_node_1.default,
};
exports.nodeTypes = __assign(__assign(__assign(__assign(__assign({}, eventNodeTypes), actionNodeTypes), integrationNodeTypes), conditionNodeTypes), lookupNodeTypes);
// Pin configurations for node types - matches the node type keys in nodeTypes
exports.NODE_PIN_CONFIGS = {
    // Event nodes
    event: {
        inputs: [],
        outputs: ["data"],
    },
    api_rest: {
        inputs: [],
        outputs: ["validated_data"],
    },
    // Action nodes
    delay: {
        inputs: [],
        outputs: [],
    },
    map_data: {
        inputs: ["data"],
        outputs: ["data"],
    },
    save_data: {
        inputs: ["data"],
        outputs: [],
    },
    template: {
        inputs: ["data"],
        outputs: ["data"],
    },
    pack_parcel: {
        inputs: ["order_id"],
        outputs: ["parcel"],
    },
    // Lookup nodes
    lookup: {
        inputs: ["key"],
        outputs: ["data"],
    },
    // Integration nodes
    webhook: {
        inputs: ["data"],
        outputs: ["response_data"],
    },
    sendgrid_email: {
        inputs: ["data"],
        outputs: [],
    },
    firebase_notification: {
        inputs: ["data"],
        outputs: [],
    },
    twilio_sms: {
        inputs: ["data"],
        outputs: [],
    },
    xero_invoice: {
        inputs: ["data"],
        outputs: ["invoice"],
    },
    // Condition/Filter nodes
    filter: {
        inputs: ["data"],
        outputs: ["data", "matched"],
    },
    and_condition: {
        inputs: ["data"],
        outputs: ["data"],
    },
    method_filter: {
        inputs: ["data"],
        outputs: ["data", "matched"],
    },
};
exports.nodeConfigurations = {
    // template: [
    //   {
    //     type: "template",
    //     data: {
    //       icon: "T",
    //       name: "Template",
    //       configurable: true,
    //       config: {}
    //     }
    //   }
    // ],
    event: [
        {
            type: "event",
            data: {
                name: "Customer Created",
                config: {
                    topic: constants_1.EVENT_TOPICS.users.CREATED,
                },
                schema: {
                    ref: models_1.User,
                },
            },
        },
        {
            type: "event",
            data: {
                name: "Loyalty User Registered",
                config: {
                    topic: constants_1.EVENT_TOPICS.loyaltyprograms.CREATED,
                },
                schema: {
                    ref: models_1.LoyaltyProgram,
                },
            },
        },
        {
            type: "event",
            data: {
                name: "Basket Created",
                config: {
                    topic: constants_1.EVENT_TOPICS.baskets.CREATED,
                },
                schema: {
                    ref: models_1.Basket,
                },
            },
        },
        {
            type: "event",
            data: {
                name: "Order Created",
                configurable: true,
                config: {
                    topic: constants_1.EVENT_TOPICS.orders.CREATED,
                    status: "",
                    comparison: "equals",
                },
                schema: {
                    ref: models_1.Order,
                },
                validation: {
                    status: {
                        type: "text",
                        required: false,
                    },
                },
            },
        },
        {
            type: "event",
            data: {
                name: "Order Viewed",
                config: {
                    topic: constants_1.EVENT_TOPICS.orders.VIEWED,
                },
                schema: {
                    ref: models_1.Order,
                },
            },
        },
        {
            type: "event",
            data: {
                name: "Parcel Created",
                config: {
                    topic: constants_1.EVENT_TOPICS.parcels.CREATED,
                },
                schema: {
                    ref: models_1.Parcel,
                },
            },
        },
        {
            type: "event",
            data: {
                name: "Order Status Change",
                configurable: true,
                config: {
                    topic: constants_1.EVENT_TOPICS.orders.STATUS_CHANGE,
                    status: "",
                },
                schema: {
                    ref: models_1.Order,
                },
            },
        },
        {
            type: "event",
            data: {
                name: "Parcel Status Change",
                configurable: true,
                config: {
                    topic: constants_1.EVENT_TOPICS.parcels.STATUS_CHANGE,
                    status: "",
                },
                schema: {
                    ref: models_1.Parcel,
                },
            },
        },
        {
            type: "event",
            data: {
                name: "Basket Timeout",
                configurable: true,
                config: {
                    topic: constants_1.EVENT_TOPICS.baskets.STATUS_CHANGE,
                    status: "",
                },
                schema: {
                    ref: models_1.Basket,
                },
            },
        },
        {
            type: "api_rest",
            data: {
                name: "REST Endpoint",
                configurable: true,
                config: {
                    topic: "api/rest",
                    fields: [],
                },
                schema: {
                    ref: {},
                },
            },
        },
        // {
        //   type: "event",
        //   data: {
        //     name: "Return Product Created",
        //     config: {
        //       topic: "returns/created",
        //     },
        //   },
        // },
        // {
        //   type: "event",
        //   data: {
        //     name: "Checkout Failed",
        //     config: {
        //       topic: "checkouts/failed",
        //     },
        //   },
        // },
        // {
        //   type: "event",
        //   data: {
        //     name: "Document Created",
        //     config: {
        //       topic: "documents/created",
        //     },
        //   },
        // },
    ],
    action: [
        {
            type: "delay",
            data: {
                name: "Delay",
                configurable: true,
                config: {
                    delay_ms: 0,
                },
            },
        },
        {
            type: "map_data",
            data: {
                name: "Map Data",
                configurable: true,
                config: {},
            },
        },
        {
            type: "save_data",
            data: {
                name: "Save Data",
                configurable: true,
                config: {
                    collectionName: "CUSTOMER",
                    destination: "",
                },
            },
        },
        {
            type: "pack_parcel",
            data: {
                name: "Pack Parcel",
                configurable: true,
                config: {},
            },
        },
    ],
    lookup: [
        {
            type: "lookup",
            data: {
                name: "Branch",
                icon: pro_light_svg_icons_1.faMagnifyingGlass,
                configurable: true,
                config: {
                    db: "client",
                    model: "clientbranches",
                    input_path: "branch._id",
                    output_path: "branch",
                },
                schema: {
                    ref: models_1.ClientBranch,
                    path: "branch",
                },
            },
        },
    ],
    integration: [
        {
            type: "webhook",
            data: {
                name: "HTTP Request",
                configurable: true,
                config: {
                    url: "",
                    auth: {},
                    requestType: "POST",
                },
            },
        },
        {
            type: "sendgrid_email",
            data: {
                name: "SendGrid Email",
                configurable: true,
                config: {
                    recipient: "",
                    template_id: "",
                },
                validation: __assign(__assign({}, (0, validateForm_1.extractValidationValues)({
                    recipient: "",
                    template_id: "",
                })), { email: {
                        type: "emailAddress",
                        dependOn: {
                            key: "recipient",
                            value: "custom",
                        },
                    } }),
            },
        },
        {
            type: "firebase_notification",
            data: {
                name: "Firebase Push Notification",
                configurable: true,
                config: {
                    target: "customer",
                    title: "",
                    topic: "",
                    device_token: "",
                    body: "",
                },
                validation: {
                    title: {
                        type: "text",
                        required: true,
                        charLength: 30,
                    },
                    topic: {
                        type: "text",
                        required: true,
                        charLength: 30,
                        dependOn: {
                            key: "target",
                            value: "topic",
                        },
                    },
                    device_token: {
                        type: "text",
                        required: true,
                        dependOn: {
                            key: "target",
                            value: "device",
                        },
                    },
                    body: {
                        type: "text",
                        required: true,
                        charLength: 120,
                    },
                },
            },
        },
        {
            type: "twilio_sms",
            data: {
                name: "Twilio SMS",
                configurable: true,
                config: {
                    recipient: "",
                    body: "",
                },
                validation: __assign(__assign({}, (0, validateForm_1.extractValidationValues)({
                    recipient: "",
                    body: "",
                })), { cell_number: {
                        type: "phoneNumber",
                        dependOn: {
                            key: "recipient",
                            value: "custom",
                        },
                    } }),
            },
        },
        {
            type: "xero_invoice",
            data: {
                name: "Xero Invoice",
                configurable: false,
                config: {},
            },
        },
    ],
    filter: [
        {
            type: "filter",
            data: {
                name: "Order: Product Category",
                configurable: true,
                config: {
                    field: "product_list.category._id",
                    value: "",
                    condition: "equals",
                },
                validation: __assign({}, (0, validateForm_1.extractValidationValues)({
                    value: "",
                })),
            },
        },
        {
            type: "method_filter",
            data: {
                name: "Order: Fullfillment Method",
                configurable: true,
                config: {
                    field: "method",
                    value: "DELIVERY",
                    condition: "equals",
                },
            },
        },
    ],
    condition: [
        {
            type: "and_condition",
            data: {
                name: "AND",
                icon: pro_light_svg_icons_1.faMerge,
                configurable: true,
                config: {
                    operation: "merge",
                },
                validation: __assign(__assign({}, (0, validateForm_1.extractValidationValues)({
                    operation: "merge",
                })), { source: {
                        type: "text",
                        dependOn: {
                            key: "operation",
                            value: "select",
                        },
                    } }),
            },
        },
    ],
};
exports.tableColumns = [
    {
        displayKey: "name",
        label: "Name",
    },
    {
        displayKey: "nodes",
        label: "Nodes",
        formatter: function (_) { var _a; return (_a = _ === null || _ === void 0 ? void 0 : _.nodes) === null || _a === void 0 ? void 0 : _a.length; },
    },
    {
        displayKey: "updatedAt",
        label: "Last Saved",
    },
];
exports.workflowEventStatusOptions = {
    baskets: objectStatuses_1.basketStatuses.map(function (status) { return ({
        label: status,
        value: status,
    }); }),
    orders: objectStatuses_1.orderStatuses.map(function (status) { return ({
        label: status,
        value: status,
    }); }),
    parcels: objectStatuses_1.parcelStatuses.map(function (status) { return ({
        label: status,
        value: status,
    }); }),
};
exports.workflowPersonaOptions = [
    {
        label: "Customer",
        value: "customer",
    },
    {
        label: "Branch-Manager",
        value: "branch-manager",
    },
    {
        label: "Admin",
        value: "admin",
    },
    {
        label: "Custom",
        value: "custom",
    },
];
